import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IDocument } from "../interface/IDocument";
import { saveByteArray } from "src/util/saveByteArray";
import { IDocumentUpload, SimpleDocumentUpload } from "../interface/IDocumentUpload";
import { FilesCategoryEnum, FilesCategoryEnumLabel } from "../enum/FilesCategoryEnum";

enum DocumentServiceEnum {
  findMarriageCertificate = "/find-marriage-certificate?tradeId=",
  downloadTradeDocument = "/",
  proxyDownload = "/proxy-download",
  downloadPaperclipDocument = "/download-paperclip-document/",
  downloadContractWithAttorneys = "/download-with-attorneys/",
  downloadUniproofDocument = "/dowload-uniproof-document/{documentId}",
  uploadMarriageCertificate = "/upload-marriage-certificate/",
  uploadLetterOfAttorney = "/upload-letter-of-attorney",
  uploadLegalProcess = "/upload-Legal-process",
  uploadContratoEscrituraPublica = "/contrato-escritura-publica/",
  uploadDiligenceDocument = "/upload-diligence-document",
  uploadProcessDocument = "/upload-process-document",
  uploadPublicDeed = "/upload-public-deed",
  uploadTedReceipt = "/upload-ted-receipt",
  uploadCessionTerm = "/upload-contract",
  getAll = "/get-documents",
  getByFileKey = "/",
  getByFileKeyToken = "/get-document-by-file-key/",
  getById = "/get-document/",
  getDocumentByTradeIdAndCategory = "/find-document-by-trade-and-categegory?tradeId={tradeId}&category={category}",
  getTermoCessao = "/dowload-termo-cessao/{tradeId}",
  getTermoAceite = "/dowload-termo-aceite/{tradeId}",
  getInstrumentoPublicoCessao = "/dowload-instrumento-publico-cessao/{tradeId}",
  getInstrumentoPublicoMandato = "/dowload-instrumento-publico-mandato/{tradeId}",
  getUniproofDocument = "/dowload-instrumento-publico-mandato/{tradeId}",
  uploadGeneric = "/upload",
  getDocumentTags = "/get-tags",
  getAllDocumentsCategories = "/get-categories",
  uploadTed = "/upload-ted",
  ted = "/ted"
}

export default class DocumentService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/document");
  }

  public getAll = async (): Promise<IDocument[]> => await this.GET(DocumentServiceEnum.getAll);
  public getAllDocumentsCategory = async (): Promise<string[]> => await this.GET(DocumentServiceEnum.getAllDocumentsCategories);
  public getById = async (id: number): Promise<IDocument> => await this.GET(DocumentServiceEnum.getById + id);

  public putUploadMarriageCertificate = async (
    id: number,
    category: string,
    file: string,
    description: string,
    storageType: string,
    tradeId: number,
    fileName: string
  ): Promise<IDocument[]> =>
    await this.PUT(DocumentServiceEnum.uploadMarriageCertificate + tradeId, {
      id,
      category,
      file,
      description,
      storageType,
      tradeId,
      fileName
    });

  public getDocumentByTradeIdAndCategory = async (tradeId, category) =>
    this.GET(DocumentServiceEnum.getDocumentByTradeIdAndCategory.replace("{tradeId}", tradeId).replace("{category}", category));
  public findMarriageCertificate = async tradeId => this.GET(DocumentServiceEnum.findMarriageCertificate + tradeId);
  public getByFileKey = async fileKey => this.GET(DocumentServiceEnum.getByFileKey + fileKey);

  public proxyDownload = async (uri: string, filename: string) => {
    const data = await this.POST(DocumentServiceEnum.proxyDownload, { uri }, "blob");

    saveByteArray(filename, data);
    return data;
  }

  public downloadDocument = async (document: IDocument, tradeId?: number, user?: string) => {
    const filename = (tradeId ? `${tradeId}_` : "") + document.fileName ? document.fileName : "documento" + (user ? `_${user}` : "") + ".docx";
    const data = await this.GET(DocumentServiceEnum.downloadTradeDocument + (document.file && document.file !== "null" ? document.file : document.path), "blob");

    saveByteArray(filename, data);
    return data;
  };

  public downloadTradeDocument = async (document: IDocument) => {
    const data = await this.GET(DocumentServiceEnum.downloadTradeDocument + document.path, "blob");
    saveByteArray(document.fileName, data);
    return data;
  };

  public downloadPaperclipDocument = async (category: FilesCategoryEnum, tradeId?: number, user?: string) => {
    const filename = (tradeId ? `${tradeId}_` : "") + FilesCategoryEnumLabel.get(category) + (user ? `_${user}` : "") + ".docx";
    const endpoint = DocumentServiceEnum.downloadPaperclipDocument + tradeId + "/" + FilesCategoryEnum[category];
    const data = await this.GET(endpoint, "blob");

    saveByteArray(filename, data);
    return data;
  };


  public downloadUniproof = async documentId => {
    const data = await this.GET(DocumentServiceEnum.downloadUniproofDocument.replace("{documentId}", documentId), "blob");
    saveByteArray("UniproofDocument.pdf", data);
    return data;
  };

  public getByFileKeyToken = async fileKeyToken => await this.GET(DocumentServiceEnum.getByFileKeyToken + fileKeyToken);
  public putUploadLetterOfAttorney = async file => await this.PUT(DocumentServiceEnum.uploadLetterOfAttorney, file);
  public putUploadLegalProcess = async file => await this.PUT(DocumentServiceEnum.uploadLegalProcess, file);

  public putUploadDiligenceDocument = async file => await this.PUT(DocumentServiceEnum.uploadDiligenceDocument, file);
  public putUploadTedReceipt = async file => await this.PUT(DocumentServiceEnum.uploadTedReceipt, file);
  public putUploadProcessDocument = async data => await this.PUT(DocumentServiceEnum.uploadProcessDocument, data);
  public putUploadPublicDeed = async data => await this.PUT(DocumentServiceEnum.uploadPublicDeed, data);
  public putUploadCessionTerm = async data => await this.PUT(DocumentServiceEnum.uploadCessionTerm, data);
  public putUploadGeneric = async (data: Omit<IDocumentUpload, "id" | "path">) => await this.PUT(DocumentServiceEnum.uploadGeneric, data);

  public getDocumentTags = async () => await this.GET(DocumentServiceEnum.getDocumentTags);

  public uploadTed = async (document: SimpleDocumentUpload) => await this.POST(DocumentServiceEnum.uploadTed, document);

  // public ted = async ({ id, tradePricing: { pricing: { pricingDisbursements } } }: ITrade, fileKey: string) => {
  //   const filename = (id ? `${id}_` : "") + pricingDisbursements.find(f => f.tedDocumentKey === fileKey)?.trigger + "TED.pdf";
  //   const data = await this.GET(`${DocumentServiceEnum.ted}?${generateQueryString({ tradeId: id, fileKey })}`, "blob");

  //   saveByteArray(filename, data);
  //   return data;
  // };
}



// WEBPACK FOOTER //
// ./src/services/api/Document.service.ts